export default "__VITE_ASSET__JRad6YQ6__"